import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const makeCallRequest = () => ({
  type: 'MAKE_CALL_REQUEST',
})

export const makeCallSuccess = (response) => ({
  type: 'MAKE_CALL_SUCCESS',
  payload: response,
})

export const makeCallFailure = (error) => ({
  type: 'MAKE_CALL_FAILURE',
  error,
})

export const makePhoneCall = (payload) => {
  return (dispatch) => {
    dispatch(makeCallRequest())

    fetch(URL.BASE_URL + URL.END_POINT.calling, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(makeCallSuccess(data))
        toast('Call initiated successfully!', { type: 'success' })
      })
      .catch((error) => {
        dispatch(makeCallFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialCallState = {
  loading: false,
  response: null,
  error: null,
}

export const makeCallReducer = (state = initialCallState, action) => {
  switch (action.type) {
    case 'MAKE_CALL_REQUEST':
      return { ...state, loading: true, error: null }
    case 'MAKE_CALL_SUCCESS':
      return { ...state, loading: false, response: action.payload, error: null }
    case 'MAKE_CALL_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
